import { discount } from "./core.js"

/**
 * The money a discount takes off the document as a whole.
 *
 * The line's mirror image, over header fields instead of a sub-array, and the
 * branch is the same shared one in `core.discount`.
 *
 * Its base is the subtotal *after* line discounts, which is what makes the two
 * levels compose: a line discount reduces what the document discount is a
 * percentage of, rather than the two both applying to the list price (36.03 §4).
 *
 * Config:
 * {
 *     logicType: 'calcFields',
 *     operationType: 'header.discount',
 *     typeField: 'documentDiscountType',
 *     valueField: 'documentDiscountValue',
 *     baseField: 'totalNetSalesAmountBeforeDiscount',
 *     targetField: 'documentDiscountAmount',
 *     decimals: 2
 * }
 */
const headerDiscount = (data, operation) => {
    const { typeField, valueField, baseField, targetField, decimals = 2 } = operation

    if (!data) return data

    return {
        ...data,
        [targetField]: discount(data[typeField], Number(data[valueField]), Number(data[baseField]), decimals)
    }
}

export default headerDiscount
